/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GiftCardOrdersQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type GiftCardOrdersQuery = {
  readonly __typename?: 'Query';
  readonly giftCardPurchaseHistory: {
    readonly __typename: 'GiftCardPurchaseHistory';
    readonly giftCardOrders: ReadonlyArray<{
      readonly __typename: 'GiftCardOrderDetail';
      readonly id: string;
      readonly purchasedAt: string;
      readonly deliveryDetail: {
        readonly __typename?: 'GiftCardDeliveryDetail';
        readonly deliveryMethods: ReadonlyArray<string>;
      };
      readonly userGiftCards: ReadonlyArray<{
        readonly __typename: 'UserGiftCard';
        readonly id: string;
        readonly balance: number;
        readonly recipientEmail: string | null;
        readonly recipientName: string;
      }>;
    }>;
  };
};

export const GiftCardOrdersDocument = gql`
  query GiftCardOrders {
    giftCardPurchaseHistory {
      __typename
      giftCardOrders {
        id
        __typename
        purchasedAt
        deliveryDetail {
          deliveryMethods
        }
        userGiftCards {
          id
          __typename
          balance
          recipientEmail
          recipientName
        }
      }
    }
  }
`;

export function useGiftCardOrdersQuery(
  options?: Omit<Urql.UseQueryArgs<GiftCardOrdersQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GiftCardOrdersQuery, GiftCardOrdersQueryVariables>({
    query: GiftCardOrdersDocument,
    ...options,
  });
}
